import { useMeetingMediaShareStore } from '@/features/meeting/store/meeting-media-share.store'

export function useMediaShare() {
  const setRoomId = useMeetingMediaShareStore((s) => s.setRoomId)
  const sharedVideos = useMeetingMediaShareStore((s) => s.sharedVideos)
  const setSharedVideos = useMeetingMediaShareStore((s) => s.setSharedVideos)
  const addSharedVideo = useMeetingMediaShareStore((s) => s.addSharedVideo)
  const removeSharedVideo = useMeetingMediaShareStore((s) => s.removeSharedVideo)
  const sharedDocuments = useMeetingMediaShareStore((s) => s.sharedDocuments)
  const setSharedDocuments = useMeetingMediaShareStore((s) => s.setSharedDocuments)
  const addSharedDocument = useMeetingMediaShareStore((s) => s.addSharedDocument)
  const removeSharedDocument = useMeetingMediaShareStore((s) => s.removeSharedDocument)

  return {
    /** Bind the persisted lists to a room; clears them when the room changes. */
    setRoomId,
    sharedVideos,
    setSharedVideos,
    addSharedVideo,
    removeSharedVideo,
    sharedDocuments,
    setSharedDocuments,
    addSharedDocument,
    removeSharedDocument,
  }
}
